import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { frame: String }

  change(event) {
    const params = new URLSearchParams(window.location.search)
    params.set("per_page", event.target.value)
    const url = `${window.location.pathname}?${params.toString()}`
    if (this.hasFrameValue) {
      visit(url, { frame: this.frameValue })
    } else {
      visit(url)
    }
  }
}
